export default {
  appName: "Akwa Ibom State CBT Portal",
  domain: process.env.NODE_ENV === 'production' ? "https://cbt.akwaibomstate.gov.ng" : "http://127.0.0.1:8000",
  localUserKey: "uy310spoiycrx7egigtinnktu97gehdkf",
}
  